import React from "react";
import { AiOutlineBulb } from "react-icons/ai";
import { BsArrowLeft } from "react-icons/bs";
import { SlArrowRight } from "react-icons/sl";
import { TbTicket } from "react-icons/tb";
import { lodge, messQue, whatsapp } from "../../assets/images";
import { ABOUT_URL, CONTACT_URL, PRIVACY_URL } from "../../constants/links";

const AboutDeex = ({ setOpenAbout }: any) => {
  return (
    <div className="fixed inset-0  flex font-manrope justify-start items-start pt-16 overflow-auto pb-16 bg-[#E7EBEE] dark:bg-primary_dark dark:bg-opacity-95  backdrop-blur-sm">
      <div
        className={` w-11/12 mds:w-8/12 md:7/12 border dark:border-[#303030] bg-white  rounded-xl mx-auto p-6 dark:bg-[#192025]   lgss:w-2/5 xxl:w-1/3 `}
      >
        <div className="w-full flex justify-start gap-6 items-center">
          <button
            onClick={() => {
              setOpenAbout(false);
            }}
          >
            <BsArrowLeft className="text-black dark:text-white text-[20px]" />
          </button>
          <h4 className="text-gray-900 dark:text-gray-100 font-sora font-semibold text-[20px]">
            About DeeX
          </h4>
        </div>
        <a
          href={ABOUT_URL}
          target="_blank"
          rel="noreferrer"
          className="bg-white dark:bg-transparent w-full mt-8 block"
        >
          <div className="flex justify-between py-5 border-b border-gray-200 dark:border-gray-600 items-center cursor-pointer">
            <div className="flex justify-start items-center gap-4">
              <div className="flex justify-center items-center  text-[24px] text-secondary_button w-[32px] h-[32px] rounded-full">
                <AiOutlineBulb />
              </div>
              <div>
                <h4 className="text-[#13181B] dark:text-gray-100 font-medium text-[15px]">
                  About Us
                </h4>
                <h4 className="text-gray-500 dark:text-gray-400 mt-1 text-[13px]">
                  Learn about us
                </h4>
              </div>
            </div>
            <SlArrowRight className="text-gray-500 dark:text-gray-400  text-[16px]" />
          </div>
        </a>
        <a
          href={ABOUT_URL}
          target="_blank"
          rel="noreferrer"
          className="bg-white dark:bg-transparent w-full  block"
        >
          <div className="flex justify-between py-5 border-b border-gray-200 dark:border-gray-600 items-center cursor-pointer">
            <div className="flex justify-start items-center gap-4">
              <div className="flex justify-center items-center  text-[24px] text-secondary_button w-[24px] h-[24px] rounded-full">
                <img
                  src={messQue}
                  className="w-full h-full object-cover"
                  alt=""
                />
              </div>
              <div>
                <h4 className="text-[#13181B] dark:text-gray-100 font-medium text-[15px]">
                  FAQs
                </h4>
                <h4 className="text-gray-500 dark:text-gray-400 mt-1 text-[13px]">
                  Answered questions about DeeX
                </h4>
              </div>
            </div>
            <SlArrowRight className="text-gray-500 dark:text-gray-400  text-[16px]" />
          </div>
        </a>
        <a
          href={CONTACT_URL}
          target="_blank"
          rel="noreferrer"
          className="bg-white dark:bg-transparent w-full  block"
        >
          <div className="flex justify-between py-5 border-b border-gray-200 dark:border-gray-600 items-center cursor-pointer">
            <div className="flex justify-start items-center gap-4">
              <div className="flex justify-center items-center  text-[28px] text-secondary_button w-[32px] h-[32px] rounded-full">
                <TbTicket className="" />
              </div>
              <div>
                <h4 className="text-[#13181B] dark:text-gray-100 font-medium text-[15px]">
                  Lodge a complaint
                </h4>
                <h4 className="text-gray-500 dark:text-gray-400 mt-1 text-[13px]">
                  Tell us if anything is wrong{" "}
                </h4>
              </div>
            </div>
            <SlArrowRight className="text-gray-500 dark:text-gray-400 text-[16px]" />
          </div>
        </a>
        <a
          href="https://wa.link/1zlp0c"
          target="_blank"
          rel="noreferrer"
          className="bg-white dark:bg-transparent w-full  block"
        >
          <div className="flex justify-between py-5 border-b border-gray-200 dark:border-gray-600 items-center cursor-pointer">
            <div className="flex justify-start items-center gap-4">
              <div className="flex justify-center items-center  text-[24px] text-secondary_button w-[24px] h-[24px] rounded-full">
                <img
                  src={whatsapp}
                  className="w-full h-full object-cover"
                  alt=""
                />
              </div>
              <div>
                <h4 className="text-[#13181B] dark:text-gray-100 font-medium text-[15px]">
                  Contact Us
                </h4>
                <h4 className="text-gray-500 dark:text-gray-400 mt-1 text-[13px]">
                  Reach us via WhatsApp
                </h4>
              </div>
            </div>
            <SlArrowRight className="text-gray-500 dark:text-gray-400 text-[16px]" />
          </div>
        </a>
        <a
          href={PRIVACY_URL}
          target="_blank"
          rel="noreferrer"
          className="bg-white dark:bg-transparent w-full  block"
        >
          <div className="flex justify-between py-5 items-center cursor-pointer">
            <div className="flex justify-start items-center gap-4">
              <div className="flex justify-center items-center  text-[24px] text-secondary_button w-[24px] h-[24px] rounded-full">
                <img
                  src={lodge}
                  className="w-full h-full object-cover"
                  alt=""
                />
              </div>
              <div>
                <h4 className="text-[#13181B] dark:text-gray-100 font-medium text-[15px]">
                  Terms and Privacy
                </h4>
                <h4 className="text-gray-500 dark:text-gray-400 mt-1 text-[13px]">
                  Read our privacy policy
                </h4>
              </div>
            </div>
            <SlArrowRight className="text-gray-500 dark:text-gray-400  text-[16px]" />
          </div>
        </a>
      </div>
    </div>
  );
};

export default AboutDeex;
